import * as React from 'react'

import moment from 'moment'

import { WeeklyRestEventModel } from 'app/models/weeklyRestModel'

import { useScene } from '../context/SceneContext'
import { useConfig } from '../context/ConfigContext'
import { PRINT_BAR_OUTLINE } from '../printStyles'
import { useRestLanes } from '../context/LanesContext'
import { BOTTOM_PADDING } from '../utils/layout'

type WeeklyRestBlockProps = {
  weeklyRest: WeeklyRestEventModel
  index: number
}

const color = '#22B14C'

const getDisplayEndTime = (weeklyRest: WeeklyRestEventModel): any => {
  const displayDuration = weeklyRest.restDuration ?? weeklyRest.formalRestDuration

  if (displayDuration == null) {
    return weeklyRest.realRestEndTime ?? (weeklyRest as any).endTime
  }

  const dur = moment.duration(displayDuration)
  const ms = dur.asMilliseconds()
  if (isNaN(ms)) {
    return weeklyRest.realRestEndTime ?? (weeklyRest as any).endTime
  }

  return moment(weeklyRest.startTime).clone().add(dur)
}

const prepareTooltipInfo = (
  weeklyRest: WeeklyRestEventModel,
): WeeklyRestEventModel => {
  const info: WeeklyRestEventModel = {
    ...weeklyRest,
    typeName: 'eventName.weeklyRest',
    color: color,
  }
  return info
}

export const WeeklyRestBlock: React.FC<WeeklyRestBlockProps> = React.memo(
  (props: WeeklyRestBlockProps) => {
    const scene = useScene()
    const { printMode } = useConfig()
    const { restLaneFor, restIsTop } = useRestLanes()

 
    if (scene.days > 1) {
      return null
    }

    const HEIGHT = scene.height - 54
    const weeklyRest = props.weeklyRest
    const displayEndTime = getDisplayEndTime(weeklyRest)

    const width = scene.widthOf(weeklyRest.startTime, displayEndTime)
    if (width <= 0) {
      return null
    }

    const position = scene.timeToX(weeklyRest.startTime)
    const itemHeight = HEIGHT / 4

    let fontSize = itemHeight
    if (fontSize > 11) {
      fontSize = 11
    }

    let fontMarginTop = 0
    if (fontSize < itemHeight) {
      fontMarginTop = (itemHeight - fontSize) / 2
    }
    const lane = restLaneFor(weeklyRest.startTime, displayEndTime)
    const isTop = restIsTop(weeklyRest.startTime, displayEndTime)

    return (
      <div
        className="tw-flex tw-flex-col tw-items-start tw-justify-end"
        style={{
          left: position,
          position: 'absolute',
          top: 0,
          bottom: 0,
          paddingBottom: BOTTOM_PADDING,
        }}
      >
        <div
          style={{
            background: color,
            boxShadow: printMode ? PRINT_BAR_OUTLINE : undefined,
            borderColor: '#000000',
            pointerEvents: 'auto',
            width,
            height: 6,
            marginBottom: lane * 6,
            borderTopLeftRadius: isTop ? 3 : 0,
            borderTopRightRadius: isTop ? 3 : 0,
          }}
          data-tip={JSON.stringify(prepareTooltipInfo(weeklyRest))}
          data-for="weeklyRestTooltip"
        >
        </div>
      </div>
    )
  },
)

WeeklyRestBlock.displayName = 'WeeklyRestBlock'
